export default __webpack_public_path__ + "static/media/IMG_0575.a7b6fbf9.jpg";